import { Col } from "react-bootstrap";

const ServicesComp = ({ icon, desc, title }) => {
  return (
    <Col className="services__servicesComp">
      <div>
        <div>
          <div className="icon">{icon}</div>
          <h4>{title}</h4>
          <p className="text">{desc}</p>
        </div>
      </div>
    </Col>
  );
};

export default ServicesComp;
